export const newFormData = () => {
  return {
    fEmpFormId: -1,
    fEmpFormEmpId: undefined,
    fEmpFormCompFormFK: undefined,
    fEmpFormCreatedTime: '',
    fEmpFormUpdatedTime: '',
    fEmpFormInfo: '',
    fEmpFormAttachmentId: -1,
    fEmpFormAttachmentName: '',
    fFormAttachment: undefined,
  };
};
